import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n/LocalizationProvider';

export default function AccessDeniedPage() {
  const { t } = useTranslation();
  return (
    <div className="panel" style={{ maxWidth: 520, margin: '0 auto' }}>
      <span className="badge">{t('access.badge')}</span>
      <h2>{t('access.title')}</h2>
      <p className="text-muted">{t('access.description')}</p>
      <Link to="/" className="link-button">
        {t('access.action')}
      </Link>
    </div>
  );
}
